// The cart's phone breakpoint, the app-wide phone boundary (`PHONE_MEDIA_QUERY`, below
// 768px): /cart switches to the stacked row (4379:12439) and the Order footer stacks.
// A caller may pass another max-width query from `design-system/breakpoints.ts` instead; the
// product page passes `TABLET_DOWN_MEDIA_QUERY` (below `DESKTOP_MIN_WIDTH`, 1024px) for its
// offer strips (ADO-3985, T12).
// Guarded for environments without matchMedia (tests, SSR), where it reports the desktop
// layout.
import { useEffect, useState } from 'react';
import { PHONE_MEDIA_QUERY } from '../design-system/breakpoints';

export const CART_NARROW_MEDIA_QUERY = PHONE_MEDIA_QUERY;

function matchesNow(mediaQuery: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function'
    ? window.matchMedia(mediaQuery).matches
    : false;
}

export function useIsNarrowViewport(mediaQuery: string = CART_NARROW_MEDIA_QUERY): boolean {
  const [narrow, setNarrow] = useState(() => matchesNow(mediaQuery));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const query = window.matchMedia(mediaQuery);
    const onChange = () => setNarrow(query.matches);
    onChange();
    // Safari before 14 ships a MediaQueryList without addEventListener; fall back
    // to its addListener/removeListener pair so the layout still follows a later
    // viewport or orientation change there.
    if (typeof query.addEventListener === 'function') {
      query.addEventListener('change', onChange);
      return () => query.removeEventListener('change', onChange);
    }
    query.addListener(onChange);
    return () => query.removeListener(onChange);
  }, [mediaQuery]);

  return narrow;
}
